import React, { useEffect, useState } from "react";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import { Box, Typography, Divider, Card, CardMedia,Grid,IconButton, Button } from "@mui/material";
import typographyStyles from "../../../theme/Typography";
import BasicButtons from "../../../components/Button";
import Dropdown from "../../../components/Dropdown";
import InputField from "../../../components/InputField";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import "../../../scss/main.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

import {
  ClassicEditor,
  AccessibilityHelp,
  Alignment,
  Autoformat,
  AutoLink,
  Autosave,
  BlockQuote,
  Bold,
  CodeBlock,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  GeneralHtmlSupport,
  Heading,
  HorizontalLine,
  Indent,
  IndentBlock,
  Italic,
  Link,
  Paragraph,
  SelectAll,
  Style,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  Underline,
  List,
  ListProperties,
  Undo,
} from "ckeditor5";
import {
  getDataHandlerWithToken,
  postDataHandlerWithToken,
  postDataHandler,
} from "../../../apiconfig/service";
import backBtn from "../../../assets/backBtn.svg";
import { commonGridStyle } from "../../../scss/style";


const addEditStyle = {
  addEditTitle: {
    ...typographyStyles.h4,
  },
  addEditLabel: {
    ...typographyStyles.h6,
  },
  radioContainer: {
    display: "flex",
  },

  addRemoveButton: {
    textTransform: "none",
    backgroundColor: "rgb(225,140,168)",
    color: "white",
    fontWeight: "400",
    fontSize: "15px",
    fontFamily: "'Poppins', sans-serif",
    boxShadow: "0 0 0.938rem 0 rgba(0, 0, 0, 0.2)",
    marginTop: "2px",
    marginLeft: "2px",
    "&:hover": {
      backgroundColor: "white",
      color: "rgb(225,140,168)",
    },
  },
};
const editorConfig = {
  toolbar: {
    items: [
      "undo",
      "redo",
      "|",
      "heading",
      "style",
      "|",
      "fontSize",
      "fontFamily",
      "fontColor",
      "fontBackgroundColor",
      "|",
      "bold",
      "italic",
      "underline",
      "bulletedList",
      "numberedList",

      "|",
      "horizontalLine",
      "link",
      "insertTable",
      "blockQuote",
      "codeBlock",
      "|",
      "alignment",
      "|",
      "outdent",
      "indent",
    ],
    shouldNotGroupWhenFull: false,
  },
  plugins: [
    AccessibilityHelp,
    Alignment,
    Autoformat,
    AutoLink,
    Autosave,
    BlockQuote,
    Bold,
    CodeBlock,
    Essentials,
    FontBackgroundColor,
    FontColor,
    FontFamily,
    FontSize,
    GeneralHtmlSupport,
    Heading,
    HorizontalLine,
    Indent,
    IndentBlock,
    Italic,
    Link,
    Paragraph,
    SelectAll,
    List,
    ListProperties,

    TextTransformation,
    Underline,
    Undo,
  ],
  fontFamily: {
    supportAllValues: true,
  },
  fontSize: {
    options: [10, 12, 14, "default", 18, 20, 22],
    supportAllValues: true,
  },
  heading: {
    options: [
      {
        model: "paragraph",
        title: "Paragraph",
        class: "ck-heading_paragraph",
      },
      {
        model: "heading1",
        view: "h1",
        title: "Heading 1",
        class: "ck-heading_heading1",
      },
      {
        model: "heading2",
        view: "h2",
        title: "Heading 2",
        class: "ck-heading_heading2",
      },
      {
        model: "heading3",
        view: "h3",
        title: "Heading 3",
        class: "ck-heading_heading3",
      },
      {
        model: "heading4",
        view: "h4",
        title: "Heading 4",
        class: "ck-heading_heading4",
      },
      {
        model: "heading5",
        view: "h5",
        title: "Heading 5",
        class: "ck-heading_heading5",
      },
      {
        model: "heading6",
        view: "h6",
        title: "Heading 6",
        class: "ck-heading_heading6",
      },
    ],
  },
  htmlSupport: {
    allow: [
      {
        name: /^.*$/,
        styles: true,
        attributes: true,
        classes: true,
      },
    ],
  },

  link: {
    addTargetToExternalLinks: true,
    defaultProtocol: "https://",
    decorators: {
      toggleDownloadable: {
        mode: "manual",
        label: "Downloadable",
        attributes: {
          download: "file",
        },
      },
    },
  },
  placeholder: "Type or paste your content here!",
};

const dropdownOptions = [
  "Trying to Conceive",
  "Pregnant",
  "Postpartum (0-6 Weeks After Birth)",
  "Beyond -(6 Weeks + After Birth (Weeks, months, Years))",
  "Babies and Kids", 
];


const se = [
  { key: "Trying to Conceive", value: "TRYINGTOCONCEIVE" },
  { key: "Pregnant", value: "PREGNANT" },
  { key: "Postpartum (0-6 Weeks After Birth)", value: "POSTPARTUM" },
  {
    key: "Beyond -(6 Weeks + After Birth (Weeks, months, Years))",
    value: "BEYOND",
  },
  { key: "Babies and Kids", value: "BABIESANDKIDS" }, // New object added
];


const EditActivation = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [thumbnail, setThumbnail] = useState(null);
  const [thumbnail2, setThumbnail2] = useState(null);
  const [editorContent, setEditorContent] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mydata, setMydata] = useState([]);
  const [charCount, setCharCount] = useState(0);
  const[activationData, setActivationData]= useState()
  const charLimit = 1200; // Set your character limit here
    const [videos, setVideos] = useState([]);
  

  const navigate = useNavigate();
  const { id } = useParams();

  const handleDropdownChange = (value) => {
    setSelectedValue(value);
    formik.setFieldValue("selectRange", value);
    setSelectedCategory("");
    setCategoryId("");
    console.log("Selected Dropdown Value:", value);
    filterCategoriesByStage(value);
  };

  const handleThumbnailChange = async (event, field) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    console.log("Selected File:", file);

    try {
      setLoading(true);
      const res = await postDataHandler("uploadVideo", formData);
      console.log("File Upload Response:", res);
      if (res.responseCode === 200) {
        setThumbnail(res.result);
        formik.setFieldValue(field, res.result);
      }
    } catch (error) {
      console.log("File Upload Error:", error);
    } finally {
      setLoading(false);
    }
  };


  const handleVideoChange = (e, index, key) => {
    const { value } = e.target;
    console.log(value,"value");
    
    setVideos((prevVideos) => {
      const updatedVideos = [...prevVideos];
      updatedVideos[index][key] = value; 
      return updatedVideos;
    });
  };

  const handleAddVideo = () => {
    setVideos([...videos, {title:"", video: "", videoKey: "" }]);
  };

  const handleDeleteVideo = (index) => {
    const updatedVideos = videos.filter((_, i) => i !== index);
    setVideos(updatedVideos);
  };



  const filterCategoriesByStage = (selectedValue) => {
    const stageValue = se.find((option) => option.key === selectedValue)?.value;
    if (stageValue) {
      const filteredCategories = mydata.filter(
        (category) => category.stage === stageValue
      );
      setCategoryList(filteredCategories);
    }
  };

  useEffect(() => {
    filterCategoriesByStage(selectedValue);
  }, [selectedValue]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const res = await getDataHandlerWithToken(`getActivateExercise`, {
          id,
        });
        if (res.responseCode === 200) {
          const data = res.result;

          setActivationData(data)
          setSelectedValue(
            se.find((option) => option.value === data.stage).key
          );
          setEditorContent(data?.learn);
          setVideos(data?.learnVideos)
     
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        console.error("Failed to fetch data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const validationSchema = Yup.object({
    selectRange: Yup.string().required("Please select a stage."),
    description: Yup.string()
      .required("Please enter description."),
  });
  const removeIds = (array) => {
    return array.map(({ _id, ...rest }) => rest);
  };
  const formik = useFormik({
    initialValues: {
      selectRange: activationData?.stage,
      videos:activationData?.learnVideos|| [],
      description:activationData?.learn,
      squeezes: activationData?.squeezes?.videoUrl || "",
      squeezesText: activationData?.squeezes?.description || "",
      reps:activationData?.reps?.videoUrl || "",
      repsText:activationData?.reps?.description || "",
      endurance: activationData?.endurance?.videoUrl || "",
      enduranceText: activationData?.endurance?.description || "",
     
     
    },
    enableReinitialize:true,
    validationSchema,
    onSubmit: async (values) => {

      const sanitizedVideos= removeIds(videos)
      try {
        
        setLoading(true);
        const res = await postDataHandlerWithToken(
          "addUpdateActivateExercise",
          {
            exerciseId: id,
            stage: se.find((option) => option.key === selectedValue).value,
            learn: editorContent,
            learnVideos: sanitizedVideos,
            squeezes: {
              description: values.squeezesText || "",
              videoUrl: values.squeezes
            },
            reps: {
              description: values.repsText || "",
              videoUrl: values.reps
            },
          endurance: {
            description: values.enduranceText || "",
            videoUrl: values.endurance
            },
          }
        );
        console.log("Edit Activation Result:", res);
        if (res.responseCode === 200) {
          toast.success(res.responseMessage);
          navigate("/activatelisting");
        } else {
          toast.error(res.data.responseMessage);
          console.error(res);
        }
      } catch (error) {
        console.error("Failed to edit activation : ", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const { handleBlur, errors, touched } = formik;

  return (
    <DashboardLayout
    sectionName="Content - Program Management"
    title="Add Activation"
  >
    <Box className="heading-container-top">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Box>
          <img
            src={backBtn}
            alt="backBtn"
            style={{
              cursor: "pointer",
            }}
            onClick={() => navigate(-1)}
          />
        </Box>
        <Typography sx={{ ...typographyStyles.h4 }}>
          Edit Activation
        </Typography>
      </Box>
    </Box>
    <Divider />
    <Box className="add-edit-container">
      <form
        className="add-edit-content-section"
        onSubmit={formik.handleSubmit}
      >
        <Box className="add-edit-content">
          <Box className="add-edit-input-container">
            <Box className="add-edit-input-label">
              <Typography sx={addEditStyle.addEditLabel}>
                Select Stage:
              </Typography>
            </Box>
            <Box className="add-edit-input-field">
              <Dropdown
                name="selectRange"
                onBlur={handleBlur}
                sx={addEditStyle.categoryInputField}
                options={dropdownOptions}
                value={selectedValue}
                onChange={handleDropdownChange}
                placeholder="Select stage"
              />
              {errors.selectRange && touched.selectRange ? (
                <p style={{ color: "red", marginTop: "5px", float: "left" }}>
                  {errors.selectRange}
                </p>
              ) : null}
            </Box>
          </Box>

          <Box className="add-edit-input-container">
            <Box className="add-edit-input-label">
              <Typography sx={addEditStyle.addEditLabel}>
                Learn How to Activate:
              </Typography>
            </Box>
            <Box
              className="add-edit-input-field ckeditor-container"
              sx={{ width: "100%" }}
            >
              <CKEditor
                editor={ClassicEditor}
                data={editorContent}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  console.log("Editor Content:", data);
                  setEditorContent(data);
                  formik.setFieldValue("description", data);
                  const plainText = data.replace(/<[^>]*>/g, "");
                  setCharCount(plainText.length);
                }}
                config={editorConfig}
              />
              {errors.description && touched.description ? (
                <p style={{ color: "red", marginTop: "5px", float: "left" }}>
                  {errors.description}
                </p>
              ) : null}
              <Typography
                variant="subtitle2"
                sx={{
                  textAlign: "right",
                  mt: 1,
                  color: charCount > charLimit ? "red" : "textSecondary",
                }}
              >
                {charCount}/{charLimit} characters
              </Typography>
            </Box>
          </Box>

          <Box className="add-edit-input-container">
            <Box className="add-edit-input-label">
              <Typography sx={addEditStyle.addEditLabel}>
                Video script and hls links:
              </Typography>
            </Box>

            <Grid container alignItems="center" sx={commonGridStyle} gap={1}>
            <Box className="add-edit-input-field">
                      {videos?.map((video, videoIndex) => (
                        <Box key={videoIndex}>
                          <Grid
                            container
                            alignItems="center"
                            sx={commonGridStyle}
                          >
                            {/* Video Title */}
                            <Grid item xs={12}>
                              <InputField
                                placeholder={`Video title ${videoIndex + 1}`}
                                value={video.title}
                                maxLength={200}
                                onChange={(e) =>
                                  handleVideoChange(
                                    e,
                                    videoIndex,
                                    "title",
                                   
                                  )
                                }
                                fullWidth
                              />
                            </Grid>

                            {/* Video Script */}
                            <Grid item xs={12} mt={2}>
                              <InputField
                                placeholder={`Video script ${videoIndex + 1}`}
                                value={video.video}
                                onChange={(e) =>
                                  handleVideoChange(
                                    e,
                                    videoIndex,
                                    "video"
                            
                                  )
                                }
                                fullWidth
                              />
                            </Grid>

                            {/* Video HLS Link */}
                            <Grid item xs={12} mt={2} mb={2}>
                              <InputField
                                placeholder={`Video HLS link ${
                                  videoIndex + 1
                                }`}
                                value={video.videoKey}
                                onChange={(e) =>
                                  handleVideoChange(
                                    e,
                                    videoIndex,
                                    "videoKey",
                                    
                                  )
                                }
                                fullWidth
                              />
                            </Grid>

                            {/* Add/Remove buttons for videos */}
                            <Grid item xs={12}>
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "10px",
                                  mt: "5px",
                                }}
                              >
                                {/* Remove Video Button */}
                                {videos.length > 0 && (
                                  <IconButton
                                    sx={{ ...addEditStyle.addRemoveButton }}
                                    onClick={() =>
                                      handleDeleteVideo(
                                        
                                        videoIndex
                                      )
                                    }
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                )}
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      ))}
                      <Button
                        sx={{
                          backgroundColor: "rgb(225, 140, 168)",
                          textTransform: "none",
                          width: "30%",
                        }}
                        variant="contained"
                        component="label"
                        onClick={() => handleAddVideo()}
                        startIcon={<AddIcon/>}
                      >
                        Add Videos
                      </Button>
                    </Box>
            </Grid>
           
          </Box>
        </Box>
        <Box className="add-edit-input-container">
          <Box className="add-edit-input-label">
            <Typography sx={addEditStyle.addEditLabel}>
            Squeezes:
            </Typography>
          </Box>
       

          <Grid container alignItems="center" sx={commonGridStyle} gap={1}>
          <Box className="add-edit-input-field">
            <InputField
              type="file"
              name="squeezes"
              acceptedFile="video/mp4"
              onChange={(e)=>handleThumbnailChange(e, "squeezes")}
              onBlur={handleBlur}
            />

            {errors.squeezes && touched.squeezes && (
              <p style={{ color: "red", marginTop: "5px", float: "left" }}>
                {errors.squeezes}
              </p>
            )}
            {formik.values.squeezes && (
              <Box>
                <Card
                  sx={{ maxWidth: 250, maxHeight: "auto", margin: "5px" }}
                >
                  <CardMedia component="video" src={formik.values.squeezes} controls />
                  <IconButton
                        aria-label="delete"
                        onClick={() => formik.setFieldValue("squeezes", "")}
                      >
                        <DeleteIcon sx={{ color: "rgb(225, 140, 168)" }} />
                      </IconButton>
                </Card>
              </Box>
            )}
          </Box>

          <Box className="add-edit-input-field">
              <InputField
                type="text"
                name="squeezesText"
                value={formik.values.squeezesText}
                maxLength={100}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter Sub Text For Video"
              />
              {formik.errors.squeezesText &&
              formik.touched.squeezesText ? (
                <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                  {formik.errors.squeezesText}
                </p>
              ) : null}
            </Box>
          
          </Grid>
        </Box>
        <Box className="add-edit-input-container">
          <Box className="add-edit-input-label">
            <Typography sx={addEditStyle.addEditLabel}>
            Reps:
            </Typography>
          </Box>
       

          <Grid container alignItems="center" sx={commonGridStyle} gap={1}>
          <Box className="add-edit-input-field">
            <InputField
              type="file"
              name="reps"
              acceptedFile="video/mp4"
              onChange={(e)=>handleThumbnailChange(e, "reps")}

              onBlur={handleBlur}
            />

            {errors.reps && touched.reps && (
              <p style={{ color: "red", marginTop: "5px", float: "left" }}>
                {errors.reps}
              </p>
            )}
            {formik.values.reps  && (
              <Box>
                <Card
                  sx={{ maxWidth: 250, maxHeight: "auto", margin: "5px" }}
                >
                  <CardMedia component="video" src={formik.values.reps } controls />

                  <IconButton
                        aria-label="delete"
                        onClick={() => formik.setFieldValue("reps", "")}
                      >
                        <DeleteIcon sx={{ color: "rgb(225, 140, 168)" }} />
                      </IconButton>
                </Card>
              </Box>
            )}
          </Box>

          <Box className="add-edit-input-field">
              <InputField
                type="text"
                name="repsText"
                value={formik.values.repsText}
                maxLength={100}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter Sub Text For Video"
              />
              {formik.errors.repsText &&
              formik.touched.repsText ? (
                <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                  {formik.errors.repsText}
                </p>
              ) : null}
            </Box>
          
          </Grid>
        </Box>

        <Box className="add-edit-input-container">
          <Box className="add-edit-input-label">
            <Typography sx={addEditStyle.addEditLabel}>
            Endurance:
            </Typography>
          </Box>
       

          <Grid container alignItems="center" sx={commonGridStyle} gap={1}>
          <Box className="add-edit-input-field">
            <InputField
              type="file"
              name="endurance"
              acceptedFile="video/mp4"
              onChange={(e)=>handleThumbnailChange(e, "endurance")}

              onBlur={handleBlur}
            />

            {errors.endurance && touched.endurance && (
              <p style={{ color: "red", marginTop: "5px", float: "left" }}>
                {errors.endurance}
              </p>
            )}
            {formik.values.endurance && (
              <Box>
                <Card
                  sx={{ maxWidth: 250, maxHeight: "auto", margin: "5px" }}
                >
                  <CardMedia component="video" src={formik.values.endurance} controls />
                  <IconButton
                        aria-label="delete"
                        onClick={() => formik.setFieldValue("endurance", "")}
                      >
                        <DeleteIcon sx={{ color: "rgb(225, 140, 168)" }} />
                      </IconButton>
                </Card>
              </Box>
            )}
          </Box>

          <Box className="add-edit-input-field">
              <InputField
                type="text"
                name="enduranceText"
                value={formik.values.enduranceText}
                maxLength={100}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter Sub Text For Video"
              />
              {formik.errors.enduranceText &&
              formik.touched.enduranceText ? (
                <p style={{ color: "red", marginTop: "2px", float: "left" }}>
                  {formik.errors.enduranceText}
                </p>
              ) : null}
            </Box>
          
          </Grid>
        </Box>
        <Box
          className="add-edit-button-section"
          sx={{ alignItems: "center", justifyContent: "center" }}
        >
          <BasicButtons
            text={"Edit"}
            disabled={loading}
            name="submit"
            type="submit"
            width={"20%"}
            loading={loading}
          />
        </Box>
      </form>
    </Box>
  </DashboardLayout>
  );
};

export default EditActivation;
